import React, { useRef } from 'react';
import PropTypes         from 'prop-types';
import classNames        from 'classnames';

import { Link }         from 'react-router-dom';

import Button           from '../Button';
import MobileMenu       from '../MobileMenu';

import useHeader        from './useHeader';

import Icons            from '../../../assets/svg/icons.js';

import config           from '../../../../etc/config.json';

import styles           from './Header.styl';

function Header(props) {
    const {
        className,
        theme
    } = props;

    const headerRef = useRef()

    const {
        handleScrollTo,
        isSticked
    } = useHeader(props, headerRef);

    function handleRenderLink(name, refName) {
        return theme !== 'light'
            ? (
                <div
                    className = {classNames(styles.menuLink, {
                        [styles.light]: theme === 'light'
                    })}
                    onClick = {handleScrollTo(refName)}
                >
                    {name}
                </div>
            )
            :
            (
                <Link
                    to = '/'
                    className = {classNames(styles.menuLink, {
                        [styles.light]: theme === 'light'
                    })}
                >
                    {name}
                </Link>
            )
    
    }

    return  (
        <div
            ref = {headerRef}
            className={classNames(styles.Header, className, {
                [styles.isSticky]: isSticked,
                [styles.stickyLight]: isSticked && theme === 'light'
            })}
        >
            <div className={styles.wrapper}>
                <div className={styles.logoBlock}>
                    <Link
                        to        = '/'
                        className = {styles.logoLink}
                    >
                        {theme==='light'
                            ? <Icons.LogoWhite className={styles.logo} />
                            : <Icons.LogoBlack className={styles.logo} />
                        }
                    </Link>
                    <div className={styles.separator} />
                    <Link
                        to        = '/'
                        className = {classNames(styles.logoNameLink, {
                            [styles.darkLogo]: theme==='light'
                        })}
                    >
                    ROIMAX
                    </Link>
                </div>
                {/* <div className={styles.menu}>
                    {handleRenderLink('Features', 'servicesRef')}
                    {handleRenderLink('Potential', 'resultsRef')}
                    {handleRenderLink('Setup', 'stepsRef')}
                    <Link
                        to        = '/contacts'
                        className = {classNames(styles.menuLink, {
                            [styles.light]: theme === 'light'
                        })}
                    >
                        Contact Us
                    </Link>
                </div> */}
                <div className={styles.menu}>
                    {handleRenderLink('Features', 'servicesRef')}
                    {handleRenderLink('Opportunities', 'opportunitiesRef')}
                    {handleRenderLink('Revolutionary', 'revolutionaryRef')}
                    {handleRenderLink('Potential', 'resultsRef')}
                    {handleRenderLink('Setup', 'stepsRef')}
                    {handleRenderLink('Availability', 'availabilityRef')}
                    <Link
                        to        = '/contacts'
                        className = {classNames(styles.menuLink, {
                            [styles.light]: theme === 'light'
                        })}
                    >
                        Contact Us
                    </Link>
                    <Link
                        to        = '/partners'
                        className = {classNames(styles.menuLink, {
                            [styles.light]: theme === 'light'
                        })}
                    >
                        Our Partners
                    </Link>
                </div>
                <div className={styles.buttonsBlock}>
                    <a
                        href        = {config.loginUrl}
                        className   = {classNames(styles.menuLink, styles.loginLink, {
                            [styles.light]: theme === 'light'
                        })}
                        target    = '_blank'
                        rel       = 'noreferrer'
                    >
                    Login
                    </a>
                
                    <div className={styles.separator} />
                
                    <Link
                        to        = '/create-account'
                        className = {styles.buttonLink}
                    >
                        <Button
                            color     = 'filled'
                            className = {styles.startButton}
                        >
                            Start free trial
                        </Button>
                    </Link>
                </div>
            </div>
            <MobileMenu />
        </div>
    );
}

Header.propTypes = {
    className : PropTypes.string,
    theme     : PropTypes.string
};

Header.defaultProps = {
    className : '',
    theme     : 'dark'
};

export default Header;
